module.exports = __webpack_public_path__ + "img/norway.d1bb2f4e.png";